export function getIds(fields) {
    let fieldIds = [];
    for (let field of fields)
        fieldIds.push(field.id);
    return fieldIds;
}

export function find(id,list)
{
    if (list !== null)
    {
        for (let obj of list)
        if (id === obj.id)
            return obj;
    }
    return null;
}

export function getSubList(source, ids) {
    let subList = [];
    if (!ids)
        return subList;
    for (let id of ids) {
        let element = find(id, source);
        if (element != null)
            subList.push(element);
    }
    return subList;
}

export function removeAll(id, list) {
    if (!list)
        return;
    for (let i = list.length - 1; i >= 0; i--)
        if (id === list[i].id)
            list.splice(i, 1);
}

export function addIfNotFound(l1, l2)
{
    if (!l2)
        return;
    for (let t of l2)
    {
        if (find(t.id, l1) == null)
            l1.push(t);
    }
}